<template>
      <v-container fill-height fluid>
            <v-layout align-center justify-center>
                <v-flex md4 sm8 xs12>
                    <v-card class="elevation-12">
                    <v-toolbar color="primary" dark>
                        <v-toolbar-title>Logowanie</v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-card-text>
                      <div v-if="!is2FARequired">
                        <v-form  @keyup.native.enter="handleLogin">
                        <v-text-field label="Identyfikator klienta" prepend-icon="fa-building" type="text" v-model="company"></v-text-field>
                        <v-text-field :error-messages="errors.collect('username')" label="Nazwa użytkownika" name="username" prepend-icon="fa-user" required type="text" v-model="username" v-validate="'required'"></v-text-field>
                        <v-text-field :error-messages="errors.collect('password')" id="password" label="Hasło" name="password" prepend-icon="fa-key" required type="password" v-model="password" v-validate="'required'"></v-text-field>
                        </v-form>
                      </div>
                      <div v-else>
                        <h3 class="text-center">Wymagane uwierzytelnianie dwuskładnikowe</h3>
                        <p class="text-center mb-4">
                          Wprowadź kod uwierzytelniający wygenerowany w aplikacji uwierzytelniającej, aby kontynuować logowanie.
                        </p>

                        <v-text-field
                            v-model="verificationCode"
                            label="Wprowadź kod z aplikacji"
                            outlined
                            dense
                            class="mt-4"
                        ></v-text-field>

                        <v-btn color="success" block class="mt-3" @click="verify2FA">
                          Zweryfikuj i Zaloguj
                        </v-btn>
                        <v-btn color="danger" block class="mt-3" @click="cancel2FA">
                          Anuluj
                        </v-btn>
                        <v-alert v-if="error" type="error" outlined class="mt-3">{{ error }}</v-alert>
                        <v-alert v-if="message" type="success" outlined class="mt-3">{{ message }}</v-alert>
                      </div>
                    </v-card-text>
                    <v-card-actions v-if="!is2FARequired">
                        <v-spacer></v-spacer>
                        <v-btn @click="handleLogin" color="primary">Zaloguj</v-btn>
                    </v-card-actions>
                    </v-card>              
                </v-flex>
            </v-layout>
         </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
    Name: 'Login',
    data() {
        return {
            username: null,
            password: null, 
            company: null,
            verificationCode: "", // 2FA code entered by the user
            is2FARequired: false, // Indicates if 2FA is required
            error: "", // Error message
            message: "" ,// S
            submitted: false,
            user2fa: null
        }
    },
    computed: {
        ...mapState('account', ['status']),        
    },
    created() {
        this.updateTitle('');
        this.logout();
    },
    methods: {
        ...mapActions('account', ['login', 'logout','login2Fa']),
        ...mapActions('title',['updateTitle']),
        verify2FA() {
          const { verificationCode } = this;
          this.error = '';
          if (!verificationCode || verificationCode.length === 0) {
            this.error = 'Wprowadź kod uwierzytelniający';
            return;
          }
          if (!/^\d{6}$/.test(verificationCode)) {
            this.error = 'Kod musi składać się z 6 cyfr';
            return;
          }
          const twoFactorToken = this.user2fa.twoFactorToken;
          const tenantId = this.user2fa.tenantId;
          this.login2Fa({code_2fa: verificationCode, token_2fa: twoFactorToken, tenantId: tenantId});
        },
        cancel2FA() {
          this.is2FARequired = false
          this.user2fa = null
          this.error = ''
          this.message = ''
        },
        handleLogin() {            
             this.$validator.validate().then(valid => {
                    if(valid)
                    {
                        const { username, password,company } = this;
                        if (username && password) {
                            
                            this.login({ username, password,company }).then(result=> {
                              if(result != null && result.requires2FA && result.twoFactorToken)
                              {
                                this.user2fa = result
                                this.is2FARequired = true
                              }
                            });

                        }
                    }
             });
        }
    }
}
</script>

<style>
    .login {
        max-width: 400px;
        margin-top: 60px;
    }
    .login h2 {
        font-size: 2.4em;
    }
    .login .field {
        margin-bottom: 16px;
    }
</style>
